'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'
import { useContext } from 'react'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'
import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'

type Props = {
  userSide?: TransactionSide | null
}

const Carrier = ({ userSide }: Props) => {
  const translate = useTranslate('conversation.get_shipping_label.modal')
  const {
    state: {
      labelOptions: { labelOptions, labelOptionsRewrite },
    },
  } = useContext(GetShippingLabelContext)

  const asset = useAsset('/assets/shipping')

  const isReturnFlow = userSide === TransactionSide.Buyer
  const CARRIER_ICON_PLACEHOLDER = 'carrier-placeholder.svg'

  const labelOptionsData = labelOptionsRewrite || labelOptions

  if (!labelOptionsData) return null

  return (
    <>
      <Spacer />
      <div className="u-flexbox">
        <Image
          src={labelOptionsData?.carrier.iconUrl}
          size="large"
          styling="rounded"
          fallbackSrc={asset(CARRIER_ICON_PLACEHOLDER)}
        />
      </div>
      <Text
        type="heading"
        alignment="center"
        width="parent"
        text={translate('send_with', {
          carrier_name: labelOptionsData?.carrier.name,
        })}
        as="p"
      />
      {!isReturnFlow && (
        <Text as="span" alignment="center" width="parent" text={translate('send_with_body')} />
      )}
    </>
  )
}

export default Carrier
